/* eslint-disable react/react-in-jsx-scope */
import { Box, Typography } from '@mui/material';
import { RiseLoader } from 'react-spinners';

const LoadingOverlay = () => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(253, 229, 236, 0.5)',
      zIndex: 99999,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <RiseLoader />
    <Typography
      variant="h6"
      sx={{ mt: 2, color: '#333' }}
    >
      Loading... Please wait
    </Typography>
  </Box>
);

export default LoadingOverlay;
